import messageConfigNotification from "./message-config-notification.png";
import messageTablePanel from "./message-table-panel.svg";
import notFound404 from "./not-found-404.svg";

/**
 * DS message / empty-state illustrations.
 *
 * - `tablePanel` — tables and panels (`message-table-panel.svg`, formerly grid.svg).
 * - `configNotification` — configuration and notifications (legacy PNG).
 * - `notFound404` — 404 pages (`not-found-404.svg`, formerly 404.svg).
 */
export const messageIllustrations = {
    tablePanel: messageTablePanel,
    configNotification: messageConfigNotification,
    notFound404,
} as const;

export type MessageIllustrationKey = keyof typeof messageIllustrations;
